module.exports = __webpack_public_path__ + "img/film1.88f696be.png";